import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState, actions } from "../../state/reducer";
import { handleOpenDatailPhoto } from "../../modals/functions";

const UserProfileMenuWidget = () => {
  const State = useSelector((state: RootState) => state);
  const profile = State.currentPersonal;

  const mainPhotos = State.currentUserPhoto.filter(item => item.category === "main_short");

  const maxId = Math.max(...mainPhotos.map(item => item.id), 0)
  
  const mainPhoto = mainPhotos.find(item => item.id === maxId);

  if (!profile || !profile?.first_name) {
    return(
      <div
      className="userProfileWidget"
      style={{
        marginTop: 10,
      }}
    ><a href="/profile/edit">
       <div className="textBlock">
       <div className="userNameText">Заполнить профиль</div>
       </div>
      </a></div>
    )
  }

  const photoUrl = mainPhoto?.url.replace("uploads/", "/files/") || "/images/profile.png"

  return (
    <div
      className="userProfileWidget"
      style={{
        marginTop: 10,
      }}
    >
      <a href="/profile">
        <div className="mainMenuItem flex personalMenuItem">
          <div className="avatarBlock">
            <img src={photoUrl} width="40" height="40" />
            <div className="onlineMark" />
          </div>
          <div className="textBlock">
            <div className="flex between">
              <div className="userNameText">{`${profile?.last_name || ""} ${profile?.first_name || ""}`}</div>
              {profile?.role && <div className="userRoleInfoText">{profile?.role}</div>}
            </div>
            <div className="flex">
              <div className="emailText">{`${profile?.telegram}`}</div>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default UserProfileMenuWidget;
